import { useEffect } from "react";

const useClickOutside = (ref, handler, exceptRefs = []) => {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      // Do nothing if clicking except refs
      for (const exceptRef of exceptRefs) {
        if (exceptRef && exceptRef.current && exceptRef.current.contains(event.target)) {
          return;
        }
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, exceptRefs]);
};

export default useClickOutside;
